$(document).ready(function(){

    // Fancy box sekcia "Novinky"- obrazky v clanku
    if($('.rtvs__news--view').length){
        $('.article .a501_image')
            .each(function(){
                $(this).wrap('<a href="' + $(this).attr('src') + '" data-fancybox="images" data-type="image"></a>');
            })
            //.fancybox({'type': 'image'});
    };

// END of document.ready    
});